<ng-container *transloco="let tr; prefix: 'dictionaries'; scope: 'dictionaries'">
  <nz-affix [nzOffsetTop]="0">
    <nz-page-header nzBackIcon (nzBack)="onBack()" [nzGhost]="false">
      <nz-page-header-title>{{ tr('entries.title') }}: {{dictionary.title | uiLabel}}</nz-page-header-title>
      <nz-page-header-subtitle>{{ tr('entries.subTitle') }}</nz-page-header-subtitle>
      <nz-page-header-extra>
        <button [hidden]="dirty" (click)="showAddEntryModal()" nz-button type="button" nzType="primary"> {{ 'button.addNew' | transloco}} </button>
        <span [hidden]="!dirty">
          <button (click)="saveEntries()" nz-button [nzLoading]="isLoading.saveEntries" type="button"> {{ 'button.save' | transloco}} </button>
          <button (click)="cancelModifications()" nz-button type="button" nzType="dashed" nzDanger> {{ 'button.cancel' | transloco}} </button>
        </span>
      </nz-page-header-extra>
    </nz-page-header>
  </nz-affix>

  <nz-collapse nzBordered="false">
    <nz-collapse-panel [nzHeader]="'filters' | transloco" [nzActive]="true">
      <div nz-row [nzGutter]="[16,24]">
        <div nz-col>
          <small>{{ tr('filter.query') }}</small>
          <input nz-input [(ngModel)]="params.query" (ngModelChange)="applyFilters(500)">
        </div>
        <div nz-col>
          <small>{{ tr('filter.expandAll') }}</small>
          <div>
            <nz-switch [(ngModel)]="expandAll" (ngModelChange)="toggleExpandAll($event)"></nz-switch>
          </div>
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>

  <nz-table #expandTable [nzData]="entries" [nzFrontPagination]="false" nzTableLayout="fixed">
    <thead>
    <tr>
      <th nzWidth="80px">#</th>
      <th nzColumnKey="seq" nzWidth="105px">{{ tr('entries.column.seq') }}</th>
      <th nzColumnKey="code">{{ tr('entries.column.code') }}</th>
      <th nzColumnKey="title">{{ tr('entries.column.title') }}</th>
      <th nzColumnKey="attributes">{{ tr('entries.column.attributes') }}</th>
      <th nzWidth="100px"></th>
      <th nzWidth="100px">#</th>
    </tr>
    </thead>
    <tbody>
      @for (data of expandTable.data; track data;) {
        @for (item of mapOfExpandedData[data.id]; track item; let ix = $index) {
          @if ((item.parent && item.parent.expand) || !item.parent) {
            <tr class="editable-row" [ngClass]="{'row-removed': item.removed}">
              <td
                [nzShowExpand]="item.childEntries.length > 0"
                [(nzExpand)]="item.expand"
                (nzExpandChange)="collapse(mapOfExpandedData[data.id], item, $event)">
              </td>
              <td>
                <div class="editable-cell" [hidden]="editIx === item.id" (click)="startEdit(item.id)">
                  {{ item.seq }}
                </div>
                <nz-input-number [(ngModel)]="item.seq" (ngModelChange)="onEntryChanged(item)" [hidden]="editIx !== item.id"/>
              </td>
              <td>
                <div (click)="startEdit(item.id)" [style]="'margin-left:' + item.level! * 20 + 'px'" class="editable-cell entry-code" [hidden]="editIx === item.id">
                  {{ item.code }}
                </div>
                <input [(ngModel)]="item.code" (ngModelChange)="onEntryChanged(item)" [style]="'margin-left:' + item.level! * 20 + 'px'" nz-input [hidden]="editIx !== item.id"/>
              </td>
              <td>
                <div class="editable-cell" [hidden]="editIx === item.id" (click)="startEdit(item.id)">
                  {{ item.title | uiLabel }}
                </div>
                <hx-label-edit (ngModelChange)="onEntryChanged(item)" [(ngModel)]="item.title" [hidden]="editIx !== item.id"/>
              </td>
              <td>
                <div class="editable-cell" [hidden]="editIx === item.id" (click)="startEdit(item.id)">
                  {{ item.attributes | json }}
                </div>
                <input [ngModel]="item.attributes | json" (ngModelChange)="attributeChange($event, data)" nz-input [hidden]="editIx !== item.id"/>
              </td>
              <td>
                <nz-switch [(ngModel)]="item.enabled" (ngModelChange)="onEntryChanged(item)" (click)="startEdit(item.id)"></nz-switch>
              </td>
              <td>
                <nz-input-group>
                  <button (click)="showAddChildEntryModal(item)" nz-button nzType="primary">
                    <i nz-icon nzType="plus" nzTheme="outline"></i>
                  </button>
                  <button (click)="toggleRemoved(item)" nz-button nzType="default" [nzDanger]="!item.removed">
                    <i nz-icon [nzType]="item.removed ? 'undo': 'delete'" nzTheme="outline"></i>
                  </button>
                </nz-input-group>
              </td>
            </tr>
          }
        }
      }
    </tbody>
  </nz-table>
</ng-container>
